
import { defineComponent, onMounted, ref, computed } from 'vue';
import { addHashtagLinks } from '@/common/utils'

export default defineComponent({
  components: {
  },
  props: {
    caption: {
      type: String,
      default: () => ''
    },
    showAd: {
      type: Boolean,
      default: false
    }
  },
  setup(props, ctx) {
    const showFourLine = ref(true)
    const textRef = ref()
    const showAction = ref(false)

    // const btnHtml = `
    //   <span class="new-expand-button" style="clear:both;float:right;">
    //     <span>More</span>
    //   </span>
    // `

    const showText = computed(() => {
      return addHashtagLinks(props.caption, props.showAd)
    })

    const clickBtn = () => {
      showFourLine.value = false
      showAction.value = false
    }

    onMounted(() => {
      textRef.value.addEventListener('click', clickBtn);
      const height = textRef.value.scrollHeight;
      const lineHeight = Number(window.getComputedStyle(textRef.value).lineHeight.match(/\d+\.*\d+/g)?.[0]);
      showAction.value = height / lineHeight >= 5;
      showFourLine.value = showAction.value
    })

    return {
      showText,
      showFourLine,
      textRef,
      showAction,
      clickBtn
    };
  },
});

